"use client";

import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function KitchenCta() {
  return <section id="kitchenremodelctaband" data-nav="dark" className="relative overflow-hidden bg-secondary text-secondary-foreground py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="mx-auto max-w-3xl text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-wider text-primary mb-4">
            Brookhaven Custom Renovations
          </span>

          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-secondary-foreground">
            Ready to Transform Your Brookhaven Kitchen?
          </h2>

          <p className="mt-5 text-base sm:text-lg text-secondary-foreground/85 leading-relaxed">
            Schedule a private on-site consultation to review your layout ideas, transparent investment ranges, and realistic project timelines.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto h-12 px-8 bg-primary text-primary-foreground font-medium rounded-md shadow-md hover:bg-primary/90 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg">
              <Link to="/ContactRequestAnEstimatePage">
                Get a Free Estimate
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-7 border-secondary-foreground/25 bg-transparent text-secondary-foreground hover:bg-secondary-foreground/10 hover:text-secondary-foreground rounded-md transition-all duration-200 hover:-translate-y-0.5">
              <a href="tel:+14708479076" className="inline-flex items-center gap-2">
                <Phone className="size-4 shrink-0 text-primary" aria-hidden="true" />
                <span>Call (470) 847-9076</span>
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}